import { render } from "./ScanRegradingModal.vue?vue&type=template&id=3462ebb4&ts=true&lang=pug"
import script from "./ScanRegradingModal.vue?vue&type=script&lang=ts"
export * from "./ScanRegradingModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__